(function () {
  if (typeof window === 'undefined') return;
  if (window.__cacowCartGuardInstalled) return;
  window.__cacowCartGuardInstalled = true;

  var CONFIG = window.cacowCartGuard || {};
  var SUB_TAG = String(CONFIG.subscriptionTag || 'assinatura').toLowerCase();

  var originalFetch = window.fetch.bind(window);
  var guardInProgress = false;

  var STORAGE_KEY = 'cacow:product-tags';
  var tagCache = new Map();

  try {
    var raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) {
      var parsed = JSON.parse(raw);
      Object.keys(parsed || {}).forEach(function (handle) {
        if (Array.isArray(parsed[handle])) {
          tagCache.set(handle, parsed[handle]);
        }
      });
    }
  } catch (e) {
    /* sessionStorage indisponível */
  }

  function persistCache() {
    try {
      var obj = {};
      tagCache.forEach(function (tags, handle) {
        obj[handle] = tags;
      });
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(obj));
    } catch (e) {
      /* quota exceeded ou indisponível */
    }
  }

  function fetchProductTags(handle) {
    if (!handle) return Promise.resolve([]);
    if (tagCache.has(handle)) return Promise.resolve(tagCache.get(handle));

    return originalFetch
      .call(window, '/products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to fetch product ' + handle);
        return res.json();
      })
      .then(function (product) {
        var tags = Array.isArray(product && product.tags) ? product.tags : [];
        tagCache.set(handle, tags);
        persistCache();
        return tags;
      })
      .catch(function () {
        tagCache.set(handle, []);
        return [];
      });
  }

  function isSubscriptionTags(tags) {
    if (!Array.isArray(tags)) return false;
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).toLowerCase() === SUB_TAG) return true;
    }
    return false;
  }

  function isSubscriptionItem(item) {
    return fetchProductTags(item && item.handle).then(isSubscriptionTags);
  }

  function getFrequencyKey(item) {
    if (!item) return null;

    if (Array.isArray(item.options_with_values)) {
      for (var i = 0; i < item.options_with_values.length; i++) {
        var opt = item.options_with_values[i];
        if (!opt) continue;
        var name = String(opt.name || '').toLowerCase();
        if (
          name.indexOf('frequ') !== -1 ||
          name.indexOf('plano') !== -1 ||
          name.indexOf('plan') !== -1
        ) {
          var value = String(opt.value || '').trim().toLowerCase();
          if (value) return value;
        }
      }
    }

    var fallback = String(item.variant_title || '').trim().toLowerCase();
    return fallback || null;
  }

  function getRequestInfo(args) {
    var input = args[0];
    var init = args[1] || {};
    var url = '';
    var method = (init.method || 'GET').toUpperCase();
    var body = init.body;

    if (typeof input === 'string') {
      url = input;
    } else if (input && typeof input === 'object') {
      url = input.url || '';
      if (input.method) method = String(input.method).toUpperCase();
    }

    return { url: url, method: method, body: body };
  }

  function extractSectionsFromBody(body) {
    if (!body) return null;
    try {
      if (typeof body === 'string') {
        var parsed = JSON.parse(body);
        return parsed && parsed.sections ? parsed.sections : null;
      }
    } catch (e) {
      /* not json */
    }
    return null;
  }

  function isAddCartUrl(url) {
    if (!url) return false;
    try {
      var pathname;
      if (/^https?:\/\//i.test(url)) {
        pathname = new URL(url).pathname;
      } else {
        pathname = url.split('?')[0];
      }
      return /\/cart\/add(?:\.js)?$/.test(pathname);
    } catch (e) {
      return /\/cart\/add(?:\.js)?(?:\?|$)/.test(url);
    }
  }

  function changeCartLine(lineKey, quantity, sections) {
    var body = { id: lineKey, quantity: quantity };
    if (sections) body.sections = sections;

    return originalFetch
      .call(window, '/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify(body)
      })
      .then(function (res) {
        return res.json().catch(function () {
          return null;
        });
      })
      .catch(function () {
        return null;
      });
  }

  function dispatchCartRefresh(detail) {
    document.dispatchEvent(new CustomEvent('theme:update:cart'));
    document.dispatchEvent(
      new CustomEvent('cacow:cart:guarded', {
        detail: detail || {}
      })
    );
  }

  function extractJustAdded(addResponse) {
    if (!addResponse || typeof addResponse !== 'object') return null;
    if (Array.isArray(addResponse.items) && addResponse.items.length) {
      return addResponse.items[addResponse.items.length - 1];
    }
    if (addResponse.variant_id) return addResponse;
    return null;
  }

  function runGuard(justAdded, sectionsParam) {
    if (guardInProgress) return Promise.resolve();
    guardInProgress = true;

    return originalFetch
      .call(window, '/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;

        return Promise.all(
          cart.items.map(function (item) {
            return isSubscriptionItem(item).then(function (isSub) {
              return {
                item: item,
                isSub: isSub,
                freqKey: isSub ? getFrequencyKey(item) : null
              };
            });
          })
        ).then(function (classifications) {
          return resolveJustAdded(justAdded, classifications).then(function (resolved) {
            var justAddedIsSub = resolved.isSub;
            var justAddedFreq = resolved.freqKey;
            var justAddedItem = resolved.item;

            var conflicting = classifications
              .filter(function (c) {
                if (justAddedItem && c.item.key === justAddedItem.key) return false;

                if (justAddedIsSub) {
                  if (!c.isSub) return true;
                  if (
                    justAddedFreq &&
                    c.freqKey &&
                    c.freqKey !== justAddedFreq
                  ) {
                    return true;
                  }
                  return false;
                }

                return c.isSub;
              })
              .map(function (c) { return c.item; });

            if (conflicting.length === 0) return;

            return removeLines(conflicting, sectionsParam).then(function (lastResponse) {
              var sectionsHtml = lastResponse && lastResponse.sections ? lastResponse.sections : null;
              dispatchCartRefresh({
                action: 'cleared-opposite',
                keptSubscription: justAddedIsSub,
                keptFrequency: justAddedFreq,
                sections: sectionsHtml
              });
            });
          });
        });
      })
      .catch(function (e) {
        if (window.console) console.warn('[cacow cart guard] error', e);
      })
      .then(function () {
        guardInProgress = false;
      });
  }

  function resolveJustAdded(justAdded, classifications) {
    if (justAdded && justAdded.variant_id) {
      var match = classifications.find(function (c) {
        return c.item.variant_id === justAdded.variant_id;
      });
      if (match) {
        return Promise.resolve({
          item: match.item,
          isSub: match.isSub,
          freqKey: match.freqKey
        });
      }
      return isSubscriptionItem(justAdded).then(function (isSub) {
        return {
          item: null,
          isSub: isSub,
          freqKey: isSub ? getFrequencyKey(justAdded) : null
        };
      });
    }

    var last = classifications[classifications.length - 1];
    return Promise.resolve({
      item: last.item,
      isSub: last.isSub,
      freqKey: last.freqKey
    });
  }

  function removeLines(items, sections) {
    var lastResponse = null;
    return items.reduce(function (chain, item, index) {
      return chain.then(function () {
        var sectionsForThis = sections && index === items.length - 1 ? sections : null;
        return changeCartLine(item.key, 0, sectionsForThis).then(function (resp) {
          if (resp) lastResponse = resp;
          return resp;
        });
      });
    }, Promise.resolve()).then(function () {
      return lastResponse;
    });
  }

  function enforceMode(targetIsSubscription, options) {
    if (guardInProgress) return Promise.resolve({ removed: 0, sections: null });
    guardInProgress = true;

    var sectionsParam = options && options.sections ? options.sections : null;

    return originalFetch
      .call(window, '/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
          return { removed: 0, sections: null };
        }

        return Promise.all(
          cart.items.map(function (item) {
            return isSubscriptionItem(item).then(function (isSub) {
              return { item: item, isSub: isSub };
            });
          })
        ).then(function (classifications) {
          var conflicting = classifications
            .filter(function (c) { return c.isSub !== targetIsSubscription; })
            .map(function (c) { return c.item; });

          if (conflicting.length === 0) return { removed: 0, sections: null };

          return removeLines(conflicting, sectionsParam).then(function (lastResponse) {
            var sectionsHtml = lastResponse && lastResponse.sections ? lastResponse.sections : null;
            dispatchCartRefresh({
              action: 'enforced-mode',
              keptSubscription: targetIsSubscription,
              sections: sectionsHtml
            });
            return { removed: conflicting.length, sections: sectionsHtml };
          });
        });
      })
      .catch(function (e) {
        if (window.console) console.warn('[cacow cart guard] enforceMode error', e);
        return { removed: 0, sections: null };
      })
      .then(function (result) {
        guardInProgress = false;
        return result;
      });
  }

  window.fetch = function () {
    var args = Array.prototype.slice.call(arguments);
    var info = getRequestInfo(args);
    var shouldGuard = !guardInProgress && info.method === 'POST' && isAddCartUrl(info.url);
    var requestSections = shouldGuard ? extractSectionsFromBody(info.body) : null;

    var promise = originalFetch.apply(window, args);

    if (!shouldGuard) return promise;

    return promise.then(function (response) {
      if (!response || !response.ok) return response;

      try {
        var clone = response.clone();
        clone
          .json()
          .then(function (data) {
            var justAdded = extractJustAdded(data);
            return runGuard(justAdded, requestSections);
          })
          .catch(function () {
            return runGuard(null, requestSections);
          });
      } catch (e) {
        runGuard(null, requestSections);
      }

      return response;
    });
  };

  document.addEventListener('theme:cart:change', function (event) {
    if (guardInProgress) return;
    var detail = event && event.detail;
    if (!detail) return;
    if (detail.type !== 'theme:product:add') return;

    var stub = detail.variantId ? { variant_id: detail.variantId } : null;
    runGuard(stub, null);
  });

  window.cacowCartGuard = window.cacowCartGuard || {};
  window.cacowCartGuard.api = {
    enforceSubscriptionOnly: function (options) { return enforceMode(true, options); },
    enforceRegularOnly: function (options) { return enforceMode(false, options); },
    isReady: true
  };
  document.dispatchEvent(new CustomEvent('cacow:cart-guard:ready'));
})();
